import React, { useMemo, type ReactNode } from 'react';
import type { MomentInput } from 'moment';
import Loading from '@intelligence/components/Loading';
import { useEventsTimeline } from '@sg/pages/StudioManagement/LiveTitles/pages/LiveVisualization/utils/eventsTimeline';
import './index.scss';

interface IProps {
  events?: any[];
  loading?: boolean;
  selectedMonth?: MomentInput;
}

const CLS = 'dbs-lto-events-timeline';

const EventsTimelineCell: React.FC<IProps> = ({
  events,
  loading = false,
  selectedMonth,
}) => {
  const eventsData = useMemo(() => ({ events: events ?? [] }), [events]);

  const { scrollRef, setRowRef, eventRows, isHighlighted } = useEventsTimeline({
    eventsData,
    selectedMonth,
  });

  let body: ReactNode;
  if (loading) {
    body = <Loading style={{ minHeight: '120px' }} />;
  } else if (eventRows.length === 0) {
    body = <div className={`${CLS}__empty`}>-</div>;
  } else {
    body = (
      <div className={`${CLS}__scroll`} ref={scrollRef}>
        <div className={`${CLS}__track`}>
          {eventRows.map(row => {
            const highlighted = isHighlighted(row.date);
            return (
              <div
                key={row.id}
                ref={setRowRef(row.id)}
                className={`${CLS}__row ${highlighted ? `${CLS}__row--active` : ''}`}
              >
                <div className={`${CLS}__date-wrap`}>
                  <div
                    className={`${CLS}__date ${highlighted ? `${CLS}__date--active` : ''}`}
                  >
                    {row.date}
                  </div>
                </div>
                <div
                  className={`${CLS}__event-main ${highlighted ? `${CLS}__event-main--active` : ''}`}
                >
                  <span className={`${CLS}__event-content`}>{row.event_content}</span>
                  {row.hasImportance && (
                    <span className={`${CLS}__event-tag ${CLS}__event-tag--high`}>High</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className={CLS}>
      <div className={`${CLS}__header`}>
        <span className={`${CLS}__title`}>Events</span>
      </div>
      <div className={`${CLS}__body`}>{body}</div>
    </div>
  );
};

export default EventsTimelineCell;
